import React from 'react';
import PropTypes from 'prop-types';
import theme from '../../themes/tradeRev/theme';
import { StyledDisclaimer, StyledInfoIcon } from './Styles';

const propTypes = {
  variant: PropTypes.oneOf(['success', 'information', 'warning', 'error'])
};

const defaultProps = {
  variant: 'information'
};

function getDisclaimerIcon(variant) {
  switch (variant) {
    case 'success':
      return 'TR5-Success_msg';
    case 'information':
      return 'TR5-Info';
    case 'warning':
      return 'TR5-Warning_msg';
    case 'error':
      return 'TR5-Error_msg';
    default:
      return 'TR5-Info';
  }
}

function getDisclaimerColor(variant) {
  switch (variant) {
    case 'success':
      return theme.COLORS.SUCCESS;
    case 'information':
      return theme.COLORS.INFO;
    case 'warning':
      return theme.COLORS.WARNING;
    case 'error':
      return theme.COLORS.ERROR;
    default:
      return theme.COLORS.INFO;
  }
}

const Disclaimer = ({ className, children, variant }) => (
  <StyledDisclaimer
    data-testid="disclaimer-wrapper"
    className={className}
    color={getDisclaimerColor(variant)}
  >
    <StyledInfoIcon
      icon={getDisclaimerIcon(variant)}
      color={getDisclaimerColor(variant)}
    />
    <div>{children}</div>
  </StyledDisclaimer>
);

Disclaimer.propTypes = propTypes;
Disclaimer.defaultProps = defaultProps;

export default Disclaimer;
